import { TrafficLightDataRule, TrafficLightFallbackState } from '@myarvato/shared/traffic-light-bubble';

export const TransportTrafficLightRuleConfig: TrafficLightDataRule = {
  red: ['EXCEPTION', 'Error', 'Warning'],
  fallback: TrafficLightFallbackState.Green,
};
